import { WineTypes } from 'shared-widget-components/src/constants/Constants';
import { WineModel, WineWidgetModel } from '../../models/WineWidgetModel';
import { useFeaturedProductContext } from 'shared-widget-components/src/providers/FeaturedProductProvider';
import { FeaturedWines } from './FeaturedWines';
import { CustomWines } from './CustomWines';

interface WinesProps {
  item: WineModel;
  wineList: WineWidgetModel[];
}

/**
 * The Wines function renders either the RecommendedWines or CustomWines component
 * based on the type prop.
 * @returns either the component `<RecommendedWineWines />` or the component `<CustomWineWines
 * />` based on the value of the `type` variable.
 */
export const Wines = ({ item, wineList }: WinesProps) => {
  const { featuredWines } = useFeaturedProductContext();

  if (item.type == WineTypes.FEATURED) {
    return <FeaturedWines item={item} wineList={featuredWines} />;
  }

  return <CustomWines item={item} wineList={wineList} />;
};
